import React from 'react'

export default function NwUnAuthorize() {
  return (
    <div>You are not authorized to view this request. Please contact purchase requisition support.</div>
  )
}
